import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact";
import { productImagePlaceholder } from "../helpers";
import SubmitButton from "./elements/SubmitButton";

export default function Autocomplete() {
  const { products, keywords } = useResponse();
  const { format } = useCurrencyFormatting();

  if (!products?.hits?.length && !keywords?.hits?.length) {
    return;
  }

  return (
    <div
      class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
      data-nosto-element="autocomplete"
    >
      <div class="ns-w-100 ns-mt-sm-auto">
        <div class="ns-autocomplete-inner">
          {products?.hits?.length > 0 && (
            <div class="ns-autocomplete-products">
              <div class="ns-autocomplete-products-inner">
                {products?.hits?.map(hit => {
                  return (
                    <AutocompleteElement key={hit.productId} hit={hit}>
                      <div data-url={hit.url} class="ns-d-flex flex-row ns-clickable ns-autocomplete-product" data-nosto-element="product">
                        <div class="ns-img-container">
                          <img class="" src={hit.imageUrl ?? productImagePlaceholder} alt={hit.name} />
                        </div>
                        <div class="ns-prod-data">
                          <div class="ns-prod-name">{hit.name}</div>
                          <div class="ns-d-flex flex-row">
                            {hit.listPrice && hit.listPrice > hit.price && <span class="ns-list-price ns-price ns-text-striked">{format(hit.listPrice)}</span>}
                            <span class={`ns-price ${hit.onDiscount ? "has-compare-price" : ""}`}>{format(hit.price)}</span>
                          </div>
                        </div>
                      </div>
                    </AutocompleteElement>
                  );
                })}
              </div>
              <SubmitButton text="See all search results" />
            </div>
          )}
          {keywords?.hits?.length > 0 && (
            <div class={`ns-autocomplete-keywords ns-d-flex ns-flex-column`}>
              <div class="ns-autocomplete-header">Popular Searches</div>
              <div class="ns-d-flex ns-flex-column">
                <Keywords hits={keywords.hits} keywordComponent={Keyword} elementComponent={Element} keywordInCategoryComponent={KeywordInCategory} />
              </div>
              {!products?.hits?.length && <SubmitButton text="Show all results" />}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Keyword({ hit }) {
  return (
    <span data-nosto-element="keyword">
      {hit?._highlight?.keyword ? (
        <span
          dangerouslySetInnerHTML={{
            __html: hit._highlight.keyword
          }}
        ></span>
      ) : (
        hit.keyword
      )}
    </span>
  );
}

function Element({ hit, keywordComponent, filter }) {
  return (
    <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-keyword">
      {keywordComponent}
    </AutocompleteElement>
  );
}

function KeywordInCategory({ category, children }) {
  return (
    <span class="ns-clickable">
      {category?.value ? (
        <span>
          {children}{" "}
          <span class="ns-keyword-in-category">
            in <span>{category.value}</span>
          </span>
        </span>
      ) : (
        children
      )}
    </span>
  );
}
